import { FC, HTMLAttributes, memo } from 'react';
import cn from 'classnames';

import styles from './Condition.module.css';

export interface ConditionProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  text: string;
  textColor?: 'white' | 'primary';
}

const Condition: FC<ConditionProps> = (props) => {
  const { className, text, textColor, ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.condition,
        {
          [styles.colorWhite]: textColor === 'white',
          [styles.colorBlack]: textColor === 'primary',
        },
        className,
      )}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};

export default memo(Condition);
